import { CampaignActionsContext } from '@/dashboards/CampaignOptimization/context/CampaignActionsContext';
import { useContext } from 'use-context-selector';

export const useCampaignActions = () => {
    const value = useContext(CampaignActionsContext);
    if (!value) {
        throw new Error('useCampaignActions must be used within a CampaignActionsProvider');
    }
    return value;
};
